export default {
	chooseMonth: '选择月份',
	chooseYear: '选择年份',
	previousMonth: '上个月',
	nextMonth: '下个月',
	previousYears: '上一年',
	nextYears: '下一年',
	sunShort: '日',
	monShort: '一',
	tueShort: '二',
	wedShort: '三',
	thuShort: '四',
	friShort: '五',
	satShort: '六',
	sunday: '星期日',
	monday: '星期一',
	tuesday: '星期二',
	wednesday: '星期三',
	thursday: '星期四',
	friday: '星期五',
	saturday: '星期六',
	janShort: '1月',
	febShort: '2月',
	marShort: '3月',
	aprShort: '4月',
	mayShort: '5月',
	junShort: '6月',
	julShort: '7月',
	augShort: '8月',
	sepShort: '9月',
	octShort: '10月',
	novShort: '11月',
	decShort: '12月',
	january: '一月',
	february: '二月',
	march: '三月',
	april: '四月',
	may: '五月',
	june: '六月',
	july: '七月',
	august: '八月',
	september: '九月',
	october: '十月',
	november: '十一月',
	december: '十二月'
};
